module.exports = __webpack_public_path__ + "img/vertical_3_2_7042.30ff28c0.png";